module.exports = __webpack_public_path__ + "media/joker.3078e3ab.wav";